import React from 'react';
import {NavLink, useRouteMatch} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import {URL_SLUG as PROFILE_URL_SLUG} from '../PersonalData';
import {URL_SLUG as SUBMISSIONS_URL_SLUG} from '../PaperSubmissionListing';
import {URL_SLUG as REVIEWS_URL_SLUG} from '../PaperSubmissionReviewListing';
import {URL_SLUG as SESSIONS_URL_SLUG} from '../PaperSubmissionSessionListing';

/**
 * Tab-Navigation für die Seiten unter "Mein Bereich"/"my area"
 *
 * @constructor
 */
const Navigation: React.FC = () => {

    const {url} = useRouteMatch();

    return (
        <nav className='my-area-navigation'>
            <NavLink activeClassName="active" to={`${url}/${PROFILE_URL_SLUG}`}>
                <FormattedMessage id="navigation.link.profile"/>
            </NavLink>
            <NavLink activeClassName="active" to={`${url}/${SUBMISSIONS_URL_SLUG}`}>
                <FormattedMessage id="navigation.link.submissions"/>
            </NavLink>
            <NavLink activeClassName="active" to={`${url}/${REVIEWS_URL_SLUG}`}>
                <FormattedMessage id="navigation.link.reviews"/>
            </NavLink>
            <NavLink activeClassName="active" to={`${url}/${SESSIONS_URL_SLUG}`}>
                <FormattedMessage id="navigation.link.sessions"/>
            </NavLink>
        </nav>
    );
};

export default Navigation;
